import { connect } from 'react-redux'
import ProviderProductDeactivateModal from '../../components/products/ProviderProductDeactivateModal'
import * as productActions from '../../state/actions/provider-products/index'
import { product } from '../../state/selectors/index'
import { IStoreState } from '../../types/index'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  const productId = state.providerProduct.deactivateProductModal.productId
  return {
    product: productId && product(state, productId),
    onCancelClick: ownProps.onCancelClick
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onDeactivateClick: (productId: string, deactivationDate: Date) => {
      return dispatch(productActions.deactivateProduct(productId, deactivationDate))
    },
    onCancelClick: () => {
      dispatch(productActions.actionCreators.productDeactivateModalHide())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProviderProductDeactivateModal)



// WEBPACK FOOTER //
// ./src/containers/products/ProviderProductDeactivateModal.ts